import React, { useState } from 'react';
import { Box, Checkbox, ListItemText, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import TextField from '../../TextField';
import { formSubtitleExtras, tabsSxExtras, tabExtras } from './tempStyling';
import FieldArray from '../../FieldArray';
import Select from '../../Select';

const recipientTabs = {
	users: 'users',
	emails: 'emails',
};

function SubscriptionRecipientTabs({ users, fd }) {
	const [selectedRecipientTab, setSelectedRecipientTab] = useState(recipientTabs.users);

	return (
		<Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
			<Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
				<Typography variant="h4" {...formSubtitleExtras}>Recipients</Typography>
				<Tabs
					value={selectedRecipientTab}
					onChange={(e, val) => setSelectedRecipientTab(val)}
					aria-label="list of recipient types"
					sx={{ display: 'flex', flex: '1 0 0', alignItems: 'center', height: '40px', borderBottom: 1, borderColor: 'divider', ...tabsSxExtras }}>

					<Tab label="User profiles" value={recipientTabs.users} {...tabExtras} />
					<Tab label="E-mail addresses" value={recipientTabs.emails} {...tabExtras} />
				</Tabs>
			</Box>
			{selectedRecipientTab === recipientTabs.users && (
				<Select
					{...fd.field('recipients')}
					label="Users"
					hideLabelIfEmpty
					selectProps={{
						multiple: true,
						renderValue: (selected) => {
							const user = users.find(({ id }) => id === selected[0]);
							if (selected.length > 1) {
								return `${user.firstName} + ${selected.length - 1}`;
							}
							return user?.firstName;
						},
					}}
					items={users.map(({ id, firstName, lastName }) => ({
						value: id,
						label: (
							<>
								<Checkbox checked={fd.model.recipients.indexOf(id) !== -1} />
								<ListItemText primary={`${firstName} ${lastName}`} />
							</>
						),
					}))}
				/>
			)}
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
				{selectedRecipientTab === recipientTabs.emails && (
					<FieldArray
						{...fd}
						noSwapBtns
						name="emails"
						update={() => fd.form.update()}
						createNew={() => ({ email: '' })}
						beforeHeader={(fld) => (
							<TextField
								fullWidth
								label="Email"
								email
								required
								outlinedInputProps={{
									onKeyDown: (e) => e.stopPropagation(),
								}}
								{...fld('email')}
							/>
						)}
					/>
				)}
			</Box>
		</Box>
	);
}

SubscriptionRecipientTabs.propTypes = {
	users: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		firstName: PropTypes.string.isRequired,
		lastName: PropTypes.string.isRequired,
		email: PropTypes.string.isRequired,
	})).isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	fd: PropTypes.object.isRequired,
};

export default SubscriptionRecipientTabs;
